import React from "react";

export default function getUserLinks({ isDemystUser, logOut }) {
  return [
    <button type="button" onClick={logOut}>
      <b>Log Out</b>
    </button>,
  ].filter(Boolean);
}
